import { render, staticRenderFns } from "./integrationCourse.vue?vue&type=template&id=4ecddb81&scoped=true"
import script from "./integrationCourse.vue?vue&type=script&lang=js"
export * from "./integrationCourse.vue?vue&type=script&lang=js"
import style0 from "./integrationCourse.vue?vue&type=style&index=0&id=4ecddb81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecddb81",
  null
  
)

export default component.exports